import { GalleryOptions_Layout_Type } from 'ricos-schema';
import loadable from '@loadable/component';
import React, { useMemo } from 'react';
import { Node_Type } from 'ricos-types';

var _LAYOUT_FIXED_STYLES;
function _createForOfIteratorHelperLoose$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2) {
    for (var _iterator = _createForOfIteratorHelperLoose$2(__getOwnPropSymbols$2(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
    }
  }
  return a;
};
var GALLERY_ITEMS_TYPES = Object.freeze({
  IMAGE: "image",
  VIDEO: "video"
});
Object.freeze([GalleryOptions_Layout_Type.THUMBNAIL, GalleryOptions_Layout_Type.SLIDER, GalleryOptions_Layout_Type.SLIDESHOW, GalleryOptions_Layout_Type.COLUMN, GalleryOptions_Layout_Type.FULLSIZE]);
var DEFAULTS = Object.freeze({
  items: [],
  options: {
    layout: {
      type: GalleryOptions_Layout_Type.GRID,
      orientation: "COLUMNS",
      horizontalScroll: true,
      numberOfColumns: 3
    },
    item: {
      crop: "FILL",
      ratio: 1
    }
  },
  containerData: {
    alignment: "CENTER",
    width: {
      size: "CONTENT"
    }
  }
});
var LAYOUT_FIXED_STYLES = (_LAYOUT_FIXED_STYLES = {}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.COLLAGE] = {
  galleryType: "Columns",
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.MASONRY] = {
  imageMargin: 5,
  isVertical: false,
  gridStyle: 0
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.GRID] = {
  imageResize: false,
  gridStyle: 1,
  galleryImageRatio: 2,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.THUMBNAIL] = {
  arrowsSize: 23,
  thumbnailSize: 120,
  floatingImages: 0
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.SLIDER] = {
  arrowsSize: 23,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.SLIDESHOW] = {
  arrowsSize: 23,
  floatingImages: 0,
  slideshowInfoSize: 0
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.PANORAMA] = {
  hasThumbnails: false,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.COLUMN] = {
  arrowsSize: 23,
  hasThumbnails: false,
  imageMargin: 5
}, _LAYOUT_FIXED_STYLES[GalleryOptions_Layout_Type.FULLSIZE] = {
  arrowsSize: 23,
  floatingImages: 0,
  slideshowInfoSize: 0
}, _LAYOUT_FIXED_STYLES);
var FIXED_STYLES = {
  gallerySizeType: "px",
  enableInfiniteScroll: true,
  titlePlacement: "SHOW_ON_HOVER",
  hoveringBehaviour: "NO_CHANGE",
  alwaysShowHover: true,
  allowHover: true,
  itemClick: "link",
  fullscreen: false,
  loveButton: false,
  allowSocial: false,
  allowDownload: false,
  mobileSwipeAnimation: "NO_EFFECT",
  gotStyleParams: true,
  videoPlay: "CLICK",
  videoLoop: false,
  videoSound: true,
  hidePlay: false,
  showVideoPlayButton: true,
  showVideoControls: true
};
var getFixedStyles = function getFixedStyles(layout) {
  return __spreadValues$2(__spreadValues$2({}, FIXED_STYLES), LAYOUT_FIXED_STYLES[layout]);
};

var GALLERY_TYPE = "wix-draft-plugin-gallery";

var _nodeViewRenderers;
function _createForOfIteratorHelperLoose$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var GalleryRenderer = function GalleryRenderer(_a) {
  var _b = _a,
    node = _b.node,
    nodeIndex = _b.nodeIndex,
    NodeViewContainer = _b.NodeViewContainer,
    props = __objRest(_b, ["node", "nodeIndex", "NodeViewContainer"]);
  var Gallery = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_gallery";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "ricos_plugin_gallery" */'./gallery.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./gallery");
        }
        return eval('require.resolve')("./gallery");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(Gallery, __spreadValues$1({
    key: node.id,
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var GalleryLoadable = function GalleryLoadable(_c) {
  var _d = _c,
    node = _d.node,
    props = __objRest(_d, ["node"]);
  return /* @__PURE__ */React.createElement(GalleryRenderer, __spreadValues$1({
    key: node.id,
    node: node
  }, props));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.GALLERY] = GalleryLoadable, _nodeViewRenderers);

function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginGallery = function pluginGallery(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.containerData), config),
    type: GALLERY_TYPE,
    nodeViewRenderers: nodeViewRenderers
  };
};

export { GALLERY_ITEMS_TYPES as G, GALLERY_TYPE as a, getFixedStyles as g, pluginGallery as p };
